import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { ToastContainerComponent } from '../../shared/components/toast-container/toast-container.component';
import { ErrorModalComponent } from '../../shared/components/error-modal/error-modal.component';
import { LayoutService } from '../../core/services/layout.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    SidebarComponent,
    NavbarComponent,
    ToastContainerComponent,
    ErrorModalComponent
  ],
  templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent {
  layoutService = inject(LayoutService);
  currentYear = new Date().getFullYear();
}
